module.exports = __webpack_public_path__ + "static/media/relaxed-carefree.afafbc6d.png";